import { call, put, select, take, takeEvery } from 'redux-saga/effects';
import { ENSURE_USER_ROLES, INITIAL_AUTHENTICATION, LOAD_USER_ROLES } from '../../actions/actionTypes';
import { Action } from '../../actions/commonActions';
import { loadUserRoles, loadUserRolesFailure, loadUserRolesSuccess } from '../../actions/userRoleActions';
import * as userRoleApi from '../../api/userRoleApi';
import { Loadable } from '../../models';
import { PageParameters } from '../../models/account';
import { QueryResult } from '../../models/queryResult';
import { UserRoles } from '../../models/state/userRolesState';
import { selectUserRoles } from '../../selectors/userRoles';

/**
 * Ensure that the user roles are present in the store and will initiate a server load if not.
 * @param action The action that invoked the saga.
 */
export function* ensureUserRolesSaga(action: Action<PageParameters>) {
  if (action.payload) {
    const userRoles: Loadable<UserRoles> = yield select(selectUserRoles);
    const param = action.payload;
    if (
      userRoles.companyId !== param.companyId ||
      userRoles.accountId !== param.accountId ||
      (userRoles.expiresOn && userRoles.expiresOn < new Date())
    ) {
      yield put(loadUserRoles(param));
    }
  }
}

/**
 * Load the user roles.
 * @param action The action that invoked the saga.
 */
export function* loadUserRolesSaga(action: Action<PageParameters>) {
  const pageParameters = action.payload;
  if (pageParameters) {
    try {
      const newAccount: QueryResult<string> = yield call(userRoleApi.get, pageParameters);
      yield put(loadUserRolesSuccess(pageParameters, newAccount));
    } catch (error: any) {
      yield put(loadUserRolesFailure(pageParameters, error));
    }
  }
}

/*
 * Initialize all sagas related to accounts
 */
export function* initUserRoleSagas() {
  yield take(INITIAL_AUTHENTICATION);
  yield takeEvery(ENSURE_USER_ROLES, ensureUserRolesSaga);
  yield takeEvery(LOAD_USER_ROLES, loadUserRolesSaga);
}
